/**
 * The incident roles a user can be assigned in. These are the ids of RoleConstants in the backend
 * (Cerrix.Incidents.Shared): the staffing endpoint keys its users by them, and an assignment
 * carries them as roleId. Change them only together with the backend.
 */
export const IncidentRoleIds = {
    reporter: "a0b0851f-1ccc-44cb-81c5-0bc82d249641",
    assessor: "0804a9b2-ae09-4fcd-aea1-0bdf2aa52093",
    responsible: "e3ffca00-4902-447d-8044-0bbda7d3d6b2",
    informed: "bf0a9f17-e7b0-44d2-b5e2-93daddade95f",
} as const;
